import { Box, Typography, Divider, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { PanelHeaderProps } from './types';

export function PanelHeader({ title, subtitle, onClose }: PanelHeaderProps) {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Tooltip title="Close panel">
          <IconButton
            onClick={onClose}
            aria-label="Close panel"
            data-testid="close-panel-button"
            size="small"
            sx={{
              color: theme => theme.palette.text.secondary,
              '&:hover': {
                color: theme => theme.palette.text.primary,
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Divider />
    </>
  );
}
